/* eslint-disable jsx-a11y/control-has-associated-label */
import React from 'react';
import { Input, TrashIcon } from '@avila-tek/ui/src';
import { Frequency, Plan } from '../../../models';

interface FrequencyInputProps {
  frequency: Frequency;
  setFormState: React.Dispatch<React.SetStateAction<Partial<Plan>>>;
  index: number;
}

function FrequencyInput({
  setFormState,
  index,
  frequency,
}: FrequencyInputProps) {
  const handleFrequencyChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    e.preventDefault();

    setFormState((formState) => {
      const newFrequency = formState.frequencies;
      newFrequency[index][e.target.name] = e.target.value;
      return {
        ...formState,
        frequencies: newFrequency,
      };
    });
  };

  const handleRemove = () => {
    setFormState((formState) => {
      const currentFrequency = [...formState.frequencies];
      currentFrequency.splice(index, 1);
      return {
        ...formState,
        frequencies: currentFrequency,
      };
    });
  };

  return (
    <div className="w-full flex md:flex-row flex-col gap-5 items-center">
      <div className="w-full md:w-1/2 pr-2">
        <Input
          value={frequency?.time}
          label="Tiempo de la suscripción en meses"
          type="text"
          name="time"
          placeholder="Ingrese el timepo de la suscripción en meses"
          onChange={handleFrequencyChange}
          required
        />
      </div>
      <div className="w-full md:w-1/2 pr-2">
        <Input
          value={frequency?.price}
          label="Valor total de la suscripción"
          type="number"
          name="price"
          placeholder="Ingrese el valor total de la suscripción"
          onChange={handleFrequencyChange}
          required
        />
      </div>
      <button
        className="flex items-center"
        type="button"
        onClick={handleRemove}
      >
        <TrashIcon className="w-6 h-6 text-danger-200 mt-5  " />
      </button>
    </div>
  );
}

export default FrequencyInput;
